import { Link, Outlet, useLocation } from 'react-router-dom';
import '../../components/settings/SettingsLayout.css';

const SettingsLayout = ({ user }) => {
  const location = useLocation();

  const menuItems = [
    { name: 'My Profile', path: '/settings/profile', icon: 'icon-user' },
    { name: 'Account', path: '/settings/account', icon: 'icon-lock' },
    { name: 'Notifications', path: '/settings/notifications', icon: 'icon-bell' },
    { name: 'Appearance', path: '/settings/appearance', icon: 'icon-moon' },
    { name: 'Install App', path: '/settings/install', icon: 'icon-phone' },
  ];

  return (
    <div
      className="settings-container"
      style={{ display: 'flex', maxWidth: '1200px', margin: '0 auto' }}
    >
      {/* LEFT SIDEBAR */}
      <aside className="settings-sidebar" style={{ width: '250px', padding: '20px' }}>
        <h2>Settings</h2>
        <nav>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </aside>

      {/* RIGHT SIDE CONTENT */}
      <main className="settings-content" style={{ flex: 1, padding: '20px' }}>
        <Outlet /> {/* This is where MyProfile.jsx renders */}
      </main>
    </div>
  );
};

export default SettingsLayout;
